import React from "react";
import logo from "../resources/logo-icon.png";
import { useFormInput, useGetApiWs } from "../../hooks/index";
import { api, apiConfig } from "../../util/api";
import { logIn, logOut } from "../../util/auth";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "./Main.css";

const Main = () => {
  const url = useGetApiWs("admin", "authentication", "login");
  const urlLogOut = useGetApiWs("admin", "authentication", "logout");
  let location = useLocation();
  let from = location.state?.from?.pathname || "/";

  const email = useFormInput("");
  const password = useFormInput("");
  const submit = async (e) => {
    e.preventDefault();
    const data = {
      email: email.value,
      password: password.value,
      device_name: "report_user",
    };
    const token = await api().post(url, data);

    if (token.data.status === "success") {
      const tokenR = token.data.response;
      console.log("respuesta", tokenR);

      const allPermissions = JSON.parse(
        tokenR.user.company_hieararchy_json_permissons
      ).permissions;
      const primeros30Permisos = allPermissions.slice(0, 30);
      const permisosRestantes = allPermissions.slice(30);

      const userData = {
        ...tokenR.user,
        company_hieararchy_json_permissons: JSON.stringify({
          permissions: primeros30Permisos,
        }),
      };

      logIn(tokenR.token, userData, permisosRestantes);

      if (
        window.location.hostname === "qa-estudios.lockreporting.com" &&
        tokenR.user.code === "CM-CUST"
      ) {
        await api()
          .post(urlLogOut, null, apiConfig())
          .then((response) => {
            logOut();
            Swal.fire({
              icon: "error",
              title: "No tiene permitido ingresar",
              showConfirmButton: false,
              timer: 1000,
            });
            email.onChange({ target: { value: "" } });
            password.onChange({ target: { value: "" } });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        Swal.fire({
          icon: "success",
          title: "Ingresando",
          showConfirmButton: false,
          timer: 1000,
        }).then(() => {
          window.location.href = "/dashboard" + from;
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Correo o Contraseña incorrecta...",
        text: "Verifica si los datos están correctos",
      });
    }
  };

  return (
    <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <img className="mx-auto h-20 mt-24 mb-20" src={logo} alt="Workflow" />
        </div>
        <form className="mt-8 space-y-6 " onSubmit={submit}>
          <div className="rounded-md -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                required
                type="email"
                id="user"
                placeholder="Email address"
                {...email}
                className="user appearance-none rounded-none relative block w-full px-3 py-2 border-b border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <div className="mt-1 rounded-md">
                <input
                  required
                  type="password"
                  placeholder="Password"
                  {...password}
                  className="mt-5 appearance-none rounded-none relative block w-full px-3 py-2 border-b border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm"
                />
              </div>
            </div>
          </div>
          <div className="boton">
            <button
              type="submit"
              className="button py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Ingresar
              <span className="absolute left-0 inset-y-0 flex items-center pl-3"></span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Main;
